import Swiper from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
// import 'swiper/css';
// import 'swiper/css/navigation';
// import 'swiper/css/pagination';

export function initProductsSwipers(root: Document | HTMLElement = document) {
  const containers = root.querySelectorAll<HTMLElement>('.products-swiper:not([data-swiper-initialized])');
  containers.forEach((el) => {
    el.dataset.swiperInitialized = '1';

    // Szukamy elementów nawigacji wewnątrz danego kontenera
    // const pagination = el.querySelector<HTMLElement>('.swiper-pagination');
    const nextEl = el.querySelector<HTMLElement>('.swiper-button-next');
    const prevEl = el.querySelector<HTMLElement>('.swiper-button-prev');

    // eslint-disable-next-line no-new
    new Swiper(el, {
      modules: [Navigation, Pagination, A11y],
      slidesPerView: 2,
      spaceBetween: 16,
      watchOverflow: true,
      grabCursor: true,
      // pagination: pagination ? { el: pagination, clickable: true } : undefined,
      navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
      breakpoints: {
        420: { slidesPerView: 2.5 },
        1000: {slidesPerView: 3.5 },
        1200: { slidesPerView: 5.5 },
      },
    });
  });
}

// document.addEventListener('DOMContentLoaded', () => {
//   initProductsSwipers();
// });

// // PS (Faceted Search / AJAX listing) – inicjalizacja po podmianie listy:
// document.addEventListener('psFacetedSearchUpdated', (e: Event) => {
//   const detail = (e as any).detail;
//   const ctx: Document | HTMLElement = detail?.productList || document;
//   initProductsSwipers(ctx);
// });

// // Fallback, gdy inny moduł podmienia markup bez eventu:
// const target = document.getElementById('js-product-list') || document.body;
// const mo = new MutationObserver(() => initProductsSwipers());
// mo.observe(target, { childList: true, subtree: true });

export function bindProductsSwiperEvents(prestashop?: any) {
  // Faceted search – event z modułu
  document.addEventListener('psFacetedSearchUpdated', (e: Event) => {
    const ctx = (e as any).detail?.productList || document;
    initProductsSwipers(ctx);
  });

  // PrestaShop event bus (jeśli dostępny)
  if (prestashop && typeof prestashop.on === 'function') {
    prestashop.on('updatedProduct', () => initProductsSwipers());
    prestashop.on('updatedCart', () => initProductsSwipers());
    prestashop.on('updateProductList', (data: any) => {
      const ctx = data?.html || document;
      initProductsSwipers(ctx);
    });
  }

  // Fallback gdy coś podmieni DOM bez eventu
  const target = document.getElementById('js-product-list') || document.body;
  const mo = new MutationObserver(() => initProductsSwipers());
  mo.observe(target, { childList: true, subtree: true });
}